export default __webpack_public_path__ + "static/media/padelstore-logo-disabled.8b9c2546.svg";